export { BrowsePrimitivesCompoundsSkeleton } from "#browse-primitives-compounds-skeleton";
